import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import FormInput from "../../components/FormInput";
import Button from "../../components/Button";
import Checkbox from "../../components/Checkbox";
import Toast from "../../components/Toast";
import ActionLoader from "../../components/ActionLoader";

import {
  SIGNIN_IN_URL,
  FORGOT_PASSWORD_URL,
  postData,
  GET_USER_SIGNIN_LOGO,
} from "../../utils/api";
import {
  storeToken,
  storeLoginDetails,
  getLoginDetails,
  getToken,
  SESSION_PROMPT_APP_DOWNLOAD_AFTER_LOGIN,
} from "../../utils/storage";

import BottomImage from "./bottom.png";
import TopImage from "./top.png";
// import Logo from './Logo.png';

import Logo1 from "../../icons/abcattech.png";
import Logo2 from "../../icons/newicons/bottomSidebarLogo.png";
import BG from "../../icons/bg.png";
import EYE from "../../icons/eye.png";
// import  Logo from '../../icons/hBird.png';

const SIGN_IN = "SIGN_IN";

const FORGOT_PASSWORD = "FORGOT_PASSWORD";

const SIGNUP = "SIGNUP";

const NEW_USER = "NEW_USER";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export const Signin = (props) => {
  const isInvite = props.match.path === "/invite";
  const {
    params: { username },
  } = props.match;
  const [email, setEmail] = useState(username ? username : "");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [seePassword, setSeePassword] = useState(false);
  const [seeConfirmPassword, setSeeConfirmPassword] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(Logo1);
  const [isEmailValid, setIsEmailValid] = useState(false);

  const [authenticationType, setAuthenticationType] = useState("SIGN_IN");

  const [checkRememberMe, setCheckRememberMe] = useState(false);

  const [toastParams, setToastParams] = useState({
    message: "",
    type: "",
    id: "",
  });

  const [isMobile, setIsMobile] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowDimensions.width < 720) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowDimensions]);

  useEffect(() => {
    if (getToken()) {
      const loginDetails = getLoginDetails() || {};
      const isMobileView = window.innerWidth < 720;
      if (loginDetails.hierarchy === 2 && !loginDetails.isKYCSubmitted) {
        props.history.push(
          isMobileView ? "/loads/active-load" : "/converters/identify"
        );
      } else {
        props.history.push("/dashboard");
      }
    }
  }, []);

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const setLogo1 = () => {
    const hostname = window.location.hostname;
    const isAllowedHost = hostname.includes("cattraders.com");
    if (isAllowedHost) {
      setCompanyLogo(null);
    } else {
      setCompanyLogo(Logo1);
    }
  };

  useEffect(() => {
    setLogo1();
  }, []);

  const handleEmailBlur = async () => {
    if (!email) {
      setLogo1();
      return;
    }

    if (!isValidEmail(email)) {
      setLogo1();
      return;
    }

    if (isInvite) {
      setLogo1();
      return;
    }

    setIsLoading(true);
    try {
      const logoData = await postData(GET_USER_SIGNIN_LOGO, {
        email,
      });
      if (logoData?.companyLogo) {
        setCompanyLogo(logoData?.companyLogo);
      }
      setIsEmailValid(true);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      setToastParams({
        type: "ERROR",
        message: e && e.error ? e.error : "Oops! Please Enter valid email id",
        id: new Date().getTime(),
      });
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      if (authenticationType === SIGN_IN) {
        const data = await postData(SIGNIN_IN_URL, {
          email,
          password,
          isRegistration: isInvite,
        });
        if (!isInvite) {
          storeToken(data.token);
        }
        // Store email with login details for access control
        storeLoginDetails({ ...data, email });
        localStorage.setItem("company URL", data.companyLogo);
        if (data.isNewUser) {
          if (data.hierarchy === 2) {
            try {
              sessionStorage.setItem(
                SESSION_PROMPT_APP_DOWNLOAD_AFTER_LOGIN,
                "1"
              );
            } catch (e) {
              /* ignore */
            }
          }
          props.history.push("new-user");
          window.location.reload();
        } else {
          const shouldOpenKyc = data.hierarchy === 2 && !data.isKYCSubmitted;
          if (shouldOpenKyc) {
            try {
              sessionStorage.removeItem("kyc-form-closed");
              sessionStorage.setItem("kyc-pending-open", "1");
            } catch (e) {
              /* ignore */
            }
          }
          if (data.hierarchy === 2) {
            try {
              sessionStorage.setItem(
                SESSION_PROMPT_APP_DOWNLOAD_AFTER_LOGIN,
                "1"
              );
            } catch (e) {
              /* ignore */
            }
          }
          if (!isMobile) {
            props.history.push("/converters/identify");
          } else {
            props.history.push("/loads/active-load");
          }

          window.location.reload();
        }
      } else if (authenticationType === FORGOT_PASSWORD) {
        const data = await postData(FORGOT_PASSWORD_URL, {
          email,
        });
        // alert("Email Sent");
        setToastParams({
          type: "SUCCESS",
          message: "Email sent successfully",
          id: new Date().getTime(),
        });
      } else if (authenticationType === SIGNUP) {
        // Validate passwords match
        if (password !== confirmPassword) {
          setToastParams({
            type: "ERROR",
            message: "Passwords do not match",
            id: new Date().getTime(),
          });
          return;
        }

        // Validate required fields
        if (!firstName || !lastName) {
          setToastParams({
            type: "ERROR",
            message: "Please fill in all required fields",
            id: new Date().getTime(),
          });
          return;
        }

        const data = await postData(SIGNIN_IN_URL, {
          email,
          password,
          firstName,
          lastName,
          isRegistration: true,
        });
        
        setToastParams({
          type: "SUCCESS",
          message: "Account created successfully! Please login.",
          id: new Date().getTime(),
        });
        
        // Switch back to sign in after successful signup
        setAuthenticationType(SIGN_IN);
        setPassword("");
        setConfirmPassword("");
        setFirstName("");
        setLastName("");
      }
    } catch (e) {
      // alert("Wrong Credentials");
      setToastParams({
        type: "ERROR",
        message:
          e && e.response && e.response.data && e.response.data.error
            ? e.response.data.error
            : authenticationType === SIGNUP
            ? "Signup failed. Please try again."
            : "Invalid Credentials",
        id: new Date().getTime(),
      });
    }
  };
  const onForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const data = await postData(FORGOT_PASSWORD_URL, {
        email,
      });
      alert("Email Sent");
    } catch (e) {
      // alert("Wrong Email");?\
    }
  };

  return (
    <div
      className=""
      style={{
        // background: `linear-gradient( rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6) ), url(${BG})`,
        backgroundImage: `url(${BG})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        height: "100vh",
        pointerEvents: isLoading ? "none" : "auto",
      }}
    >
      <div>
        <div className="bg-black page-center box-shadow wt-100p ht-550 op-7"></div>
        <form
          onSubmit={onSubmit}
          style={{ padding: "30px 50px", borderRadius: "30px" }}
          className="page-center box-shadow wt-400 bg-white"
        >
          {/* <h1 className="t-center mb-40 mt-40">Login</h1> */}
          <div className="t-center ">
            {companyLogo && (
              <img src={companyLogo} className="wt-200 ht-75 mb-24" />
            )}
            <img src={Logo2} className="wt-200" />
          </div>
          <div className="" style={{ margin: "auto" }}>
            <div className="mt-20 mb-20">
              <FormInput
                inputClassName="rounded-pill bg-blue"
                inputType="login"
                isBlurEnabled={true}
                placeholder="Email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                onBlurChanges={handleEmailBlur}
                value={email}
                type="email"
              />
            </div>
            {authenticationType === SIGNUP && (
              <>
                <div className="mb-20">
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    inputType="login"
                    placeholder="First Name"
                    onChange={(e) => {
                      setFirstName(e.target.value);
                    }}
                    value={firstName}
                    type="text"
                  />
                </div>
                <div className="mb-20">
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    inputType="login"
                    placeholder="Last Name"
                    onChange={(e) => {
                      setLastName(e.target.value);
                    }}
                    value={lastName}
                    type="text"
                  />
                </div>
              </>
            )}
            {(authenticationType === SIGN_IN || authenticationType === SIGNUP) && (
              <div className="mb-20 p-relative">
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  inputType="login"
                  placeholder="Password"
                  type={seePassword ? "text" : "password"}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  value={password}
                  disabled={!isInvite && authenticationType === SIGN_IN ? !isEmailValid : false}
                />
                <img
                  src={EYE}
                  style={{ top: isMobile ? 34 : 49 }}
                  className="wt-25 p-absolute   r-4  c-pointer"
                  onClick={(e) => {
                    setSeePassword(!seePassword);
                  }}
                />
              </div>
            )}
            {authenticationType === SIGNUP && (
              <div className="mb-20 p-relative">
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  inputType="login"
                  placeholder="Confirm Password"
                  type={seeConfirmPassword ? "text" : "password"}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                  }}
                  value={confirmPassword}
                />
                <img
                  src={EYE}
                  style={{ top: isMobile ? 34 : 49 }}
                  className="wt-25 p-absolute   r-4  c-pointer"
                  onClick={(e) => {
                    setSeeConfirmPassword(!seeConfirmPassword);
                  }}
                />
              </div>
            )}
            {authenticationType === SIGN_IN && !isInvite && (
              <div className="mt-32 flex flex-middle">
                <Checkbox
                  isSelected={checkRememberMe}
                  label="Remember me"
                  onClick={() => {
                    setCheckRememberMe(!checkRememberMe);
                  }}
                  labelClassName="c-black fs-12"
                />
                {/* <span className="pl-8">Remember me</span> */}
              </div>
            )}
            <div className="mt-20 mb-20 t-center">
              {authenticationType === SIGN_IN && !isInvite && (
                <>
                  <span className="fs-12 c-black">
                    Don't have an account?{" "}
                    <Link to="/signup" className="fs-12 c-pointer c-blue">
                      Sign Up
                    </Link>
                  </span>
                  {/* <div className="mt-12">
                    <Link to="/franchise-signup" className="fs-12 c-pointer c-blue">
                      Franchise Enrollment
                    </Link>
                  </div> */}
                </>
              )}
              {authenticationType === SIGNUP && (
                <span
                  className="fs-12 c-pointer c-black"
                  onClick={() => {
                    setAuthenticationType(SIGN_IN);
                    setPassword("");
                    setConfirmPassword("");
                    setFirstName("");
                    setLastName("");
                  }}
                >
                  Already have an account? <span className="c-blue">Sign In</span>
                </span>
              )}
            </div>
            <div className=" flex flex-between flex-middle">
              {authenticationType === SIGN_IN && !isInvite && (
                <span
                  className="fs-12 c-pointer c-black"
                  onClick={() => {
                    setAuthenticationType(FORGOT_PASSWORD);
                  }}
                >
                  Forgot Password?
                </span>
              )}
              {authenticationType === FORGOT_PASSWORD && !isInvite && (
                <span
                  className="fs-12 c-pointer c-black"
                  onClick={() => {
                    setAuthenticationType(SIGN_IN);
                  }}
                >
                  Signin
                </span>
              )}
              {authenticationType === SIGN_IN && (
                <Button className="btn">
                  {" "}
                  {isInvite ? "Register" : "Login"}
                </Button>
              )}
              {authenticationType === FORGOT_PASSWORD && (
                <Button className="btn">Send Email</Button>
              )}
              {authenticationType === SIGNUP && (
                <Button className="btn">Sign Up</Button>
              )}
            </div>
          </div>
        </form>
      </div>
      <Toast
        type={toastParams.type}
        message={toastParams.message}
        id={toastParams.id}
      />
      {isLoading && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <ActionLoader />
        </div>
      )}
    </div>
  );
};
export default Signin;
